import { render } from "./VLorem.vue?vue&type=template&id=0e239274"
const script = {}

import "./VLorem.vue?vue&type=style&index=0&id=0e239274&lang=scss"

import exportComponent from "E:\\Project\\Vue\\keep-calm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__